import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

function ServiceSection() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch("https://backend.ohanyanlegal.am/688787d8ff144c502c7/api/services/page/");

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        setServices(Array.isArray(data.services) ? data.services : []);
      } catch (error) {
        console.error("Fetch error:", error);
        setError("Failed to load services");
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return (
      <section className="service-section bg-white">
        <div className="divider"></div>
        <div className="container">
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
            <p className="mt-2">Loading services...</p>
          </div>
        </div>
        <div className="divider"></div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="service-section bg-white">
        <div className="divider"></div>
        <div className="container">
          <div className="text-center py-5">
            <p className="text-danger">Error: {error}</p>
            <button
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>
        </div>
        <div className="divider"></div>
      </section>
    );
  }

  return (
    <section className="service-section bg-white">
      <div className="divider"></div>

      <div className="container">
        <div className="row g-5">

          <div className="">
            <div className="section-heading pe-lg-4">
              <div className="sub-title">
                <img src="assets/img/core-img/hammer.png" alt="" />
                Մեր Ծառայությունները
              </div>
            </div>
          </div>

          <div className="col-12 col-md-8">
            {services.length > 0 ? (
              <Swiper
                modules={[Navigation]}
                navigation={{
                  nextEl: ".service-button-next",
                  prevEl: ".service-button-prev",
                }}
                spaceBetween={30}
                slidesPerView={2}
                loop={true}
                className="service-swiper-slider"
              >
                {services.map((service) => (
                  <SwiperSlide key={service.id}>
                    <Link to="/service" className="swiper-slide">
                      <div className="service-slide-card">
                        <div className="title">{service.title}</div>
                        <p>{service.description}</p>

                      </div>
                    </Link>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="text-center py-5">
                <p>No services available at the moment.</p>
              </div>
            )}
          </div>

          {services.length > 0 && (
            <div className="col-12">
              <div className="swiper-navigation-container service-swiper-slider-navigation">
                <div className="service-button-prev">
                  <i className="ti ti-arrow-left"></i>
                </div>
                <div className="service-button-next">
                  <i className="ti ti-arrow-right"></i>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="divider"></div>
    </section>
  );
}

export default ServiceSection;
